import { render, staticRenderFns } from "./AskListItemQuestion.vue?vue&type=template&id=53e328d8&scoped=true&"
import script from "./AskListItemQuestion.vue?vue&type=script&lang=js&"
export * from "./AskListItemQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AskListItemQuestion.vue?vue&type=style&index=0&id=53e328d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e328d8",
  null
  
)

export default component.exports